import styled from 'styled-components'

export const TooltipTemplate = styled.div`
border-radius: 6px;
box-shadow: -1px 1px 4px 0 #d8dcea;
background-color: #f6f7fb;
padding: 16px;
min-width: 173px;
& h4 {
  font-size: 9px;
  font-weight: 300;
  text-transform: uppercase;
  color: #3e4c57;
}
& .tooltip__header, .tooltip__footer {
  display: flex;
  flex-direction: column;
}
& .tooltip__header {
  & span {
    font-size: 12px;
    color: #8ddbcd;
  }
  margin-bottom: 10px;
}
& .tooltip__footer {
  &_today {
    & span {
      font-size: 16px;
      font-weight: bold;
      color: #589ffb;
    }
  }
  &_comparison {
    margin-top: 10px;
    & span {
      font-size: 16px;
      font-weight: bold;
      color: #ff704e;
    }
  }
}
`

export const StyledChart = styled.div`
max-width: 100%;
height: auto;
border-radius: 10px;
border: 1px solid #CDCDCD;
background-color: #ffffff;
margin: 20px 0;
padding: 20px;
position: relative;

@media (max-width: 768px){
  padding: 15px 15px 15px 0;
  & tspan{
    font-size: 10px;
  }
}

@media (max-width: 563px){
  & tspan{
    font-size: 8px;
  }
}

& .dchart {
  &__no_data {
    min-height: 400px;
  }
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    @media (max-width: 768px){
      padding-left: 20px;
    }
  }
  &__title {
    font-size: 24px;
    font-weight: 600;
    color: #565656;
  }
  &__date_interval {
    font-size: 12px;
    color: #8ddbcd;
  }
  &__total {
    text-align: right;
    &__label {
      font-size: 10px;
      font-weight: 300;
      color: #3e4c57;
      text-transform: uppercase;
    }
    &__value {
      font-size: 18px;
      font-weight: bold;
      color: #589ffb;
    }
  }
}

& .dxc-legend text{
  @media (max-width: 370px){
    font-size: 10px;
  }
}
`
export const StyledChartAndChildren = styled.div`

`

export const StyledMultiPieChart = styled.div`

`


export const StyledSplineChart = styled.div`
  display: flex;
  flex-direction: column;
`
